import { ILanguage } from "../types";

export const da: ILanguage = {
  translation: {
    root: {
      customize: "Tilpas",
      businessAccount: "Forretningskonto",
      verificationStatus: "Verifikationsstatus",
      companyInformation: "Virksomhedsoplysninger",
      note: "Note",
      mode: "Tilstand",
      comments: "Kommentarer",
      businessName: "Forretningsnavn",
      enterBusinessName: "Indtast forretningsnavn",
      registrationNumber: "Virksomhedsreg. ",
      registrationNumberPlaceholder: "Indtast registreringsnummer",
      taxVat: "Skat/momsregistrering nr.",
      vatPlaceholder: "Indtast skat/momsregistreringsnummer",
      registeredAddress: "Registreret adresse*",
      tradingAddress: "Handelsadresse*",
      sameAsRegisteredAddress: "Samme som registreret adresse",
      billingInformation: "Faktureringsoplysninger",
      billingPhoneNo: "Faktureringstelefon nr.*",
      phonePlaceholder: "Indtast telefonnummer",
      middleName: "Mellemnavn",
      middleNameLabel: "Mellemnavn",
      enterMiddleName: "Indtast mellemnavn",
      billingEmail: "Fakturerings -e -mail*",
      emailPlaceholder: "Indtast fakturerings -e -mail",
      driverDetails: "Driveroplysninger",
      customerVerificationStatus: "Kundeverifikationsstatus",
      enterNationalInsuranceNumber: "Indtast det nationale forsikringsnummer",
      enterYourProfession: "Indtast dit erhverv",
      enterDriving: "Gå ind i kørsel",
      profileImage: "Profilbillede",
      number: "Antal",
      image: "Billede",
      uploadBack: "Upload tilbage",
      uploadFront: "Upload front",
      issuedBy: "Udstedt af",
      document: "Dokument",
      selectDocument: "Vælg dokument",
      addFile: "Tilføj fil",
      noDataFound: "Ingen data fundet",
      noDocumentsFound: "Ingen dokumenter fundet",
      documentUpdatedAt: "Dokument opdateret kl",
      editExpiryDate: "Rediger udløbsdato",
      selectExpiryDate: "Vælg udløbsdato",
      selectExpiryDateUpload: "Vælg en udløbsdato inden upload.",
      status: "Status",
      images: "Billeder",
      profession: "Erhverv",
      nationality: "Nationalitet",
      driving: "Kørsel",
      listOfDocumentsUploaded: "Liste over uploadet dokumenter",
      listOfRequiredDocumentsUploaded:
        "Liste over nødvendige dokumenter, der er uploadet",
      documentType: "Dokumenttype",
      documentName: "Dokumentnavn",
      expiryDate: "Udløbsdato",
      confirmDelete: "Bekræft slet",
      actions: "Handlinger",
      completed: "Afsluttet",
      pending: "Indtil",
      documentDeleteConfirmMsg:
        "Er du sikker på, at du vil slette dette dokument?",
      address: "Adresse",
      useRegisteredAddress: "Brug registreret adresse",
      billingEmailAddress: "Fakturering af e -mail -adresse*",
      billingEmailLabel: "Fakturering af e -mail -adresse",
      accountNumber: "Kontonummer",
      firstName: "Fornavn*",
      lastName: "Efternavn*",
      firstNameLabel: "Fornavn",
      lastNameLabel: "Efternavn",
      contactEmail: "Kontakt e -mail -adresse*",
      emailLabel: "E -mail -adresse",
      contactPhone: "Kontakt telefonnr.*",
      registeredAddressCaps: "Registreret adresse",
      tradingAddressCaps: "Handelsadresse",
      billingInformationCaps: "Faktureringsoplysninger",
      customerContactCaps: "Kundekontakt",
      contactEmailInvalid: "Indtast en gyldig kontakt -e -mail.",
      typeAddress: "Skriv adresse",
      taxFees: "Skatter og gebyrer",
      vatTax: "Moms/skat",
      registrationNum: "Registreringsnummer",
      drivingLicenceNumber: "Kørelicensnummer",
      invalidPhoneNumber: "Ugyldigt telefonnummer",
      onStartEmail: "Vi har e -mailet dig om, hvordan du kommer i gang.",
      emailNotSeen:
        'Hvis du ikke ser e -mailen på få minutter, skal du kontrollere din "Junk Mail" eller "Spam -mappe.',
      registerNow: "Tilmeld dig nu",
      email: "E -mail",
      thankYou: "Tak",
      pickUpLocation: "Pick-up placering",
      returnLocation: "Returplacering *",
      pickUpDate: "Afhentningsdato *",
      pickUpTime: "Afhentningstid *",
      invalidPickupLeadTime: "Den valgte afhentningsdato/tid er uden for det tilladte bookingsvindue",
      dropOffDate: "Afleveringsdato *",
      searchVehicles: "Søg i køretøjer",
      chooseLocation: "Indtast et sted eller et postnummer",
      vehicleGallery: "Køretøjsgalleri",
      privacyPolicy: "Privatlivspolitik",
      termsAndConditions: "Vilkår og betingelser",
      dropOffTime: "Drop-off tid *",
      noVehiclesFound: "Ingen køretøjer fandt matchende de valgte kriterier",
      noRecordFound: "Beklager, ingen matchende poster fundet!",
      vehicles: "Køretøjer",
      endDate: "Slutdato",
      startDate: "Startdato",
      past: "Forbi",
      search: "Søge",
      upcoming: "Kommende",
      current: "Strøm",
      all: "Alle",
      more: "Mere",
      toBeAssigned: "Skal tildeles",
      ref: "Ref",
      reservation: "Reservation",
      booking: "Reservation",
      pricingSummary: "Prisfastsættelsesoversigt",
      bookingSummary: "Resume af resume",
      subscriptionVehicle: "Abonnementskøretøj",
      insurance: "Forsikring",
      addons: "Tilføjelser",
      protectionPlan: "Beskyttelsesplan",
      initialRental: "Indledende lejebetaling",
      enrollmentFee: "Tilmeldingsgebyr",
      quantity: "Mængde",
      subscriptionPrice: "Abonnementspris",
      weekly: "Ugentlig",
      monthly: "Månedlig",
      on: "På",
      numberOfDoors: "Antal døre",
      numberOfSeats: "Antal sæder",
      transmission: "smitte",
      fuelType: "Brændstoftype",
      week: "Uge",
      day: "Dag",
      hour: "Time",
      month: "Måned",
      gropu1Icon: "Gruppe1 -ikon",
      vatInclusive: "Moms inklusive",
      vat: "Moms",
      rental: "Leje",
      speedometer: "speedometer",
      available: "Tilgængelig",
      priceLowToHigh: "Pris lav til høj",
      priceHighToLow: "Pris høj til lav",
      weHaveSmartCars: "Vi har smarte biler",
      keylessSupport:
        "Vi leverer nøglefri adgangssupport med vores smarte biler",
      keylessVehicles: "Vis nøglefri køretøjer",
      duration: "Varighed",
      swapsAllowed: "Swaps tilladt",
      enrollmentAmount: "Tilmeldingsbeløb",
      subscriptionAmount: "Abonnementsbeløb",
      mileageLimit: "Kilometergrænse",
      unlimited: "Ubegrænset",
      weeks: "Uger",
      months: "Måneder",
      pricePerExtraMile: "Pris pr. Ekstra mil",
      insurancePolicy: "Forsikringspolice",
      removeSubscription: "Fjern abonnement",
      noGroupFound: "Ingen grupper fundet med matchende kriterier!",
      vehicleTypeIcon: "ikon for køretøjstype",
      min: "Min",
      selected: "Valgt",
      vehiclesSelected: "Valgte køretøjer",
      selectVehicles: "Vælg køretøjer",
      personalDetails: "Personlige detaljer",
      selectAddons: "Vælg tilføjelser",
      continue: "Fortsætte",
      locationSurcharge: "Placeringsafgift",
      onTotalRentalAmount: "På det samlede lejebeløb",
      oneWayFee: "En måde gebyr",
      oneWayRentalCharge: "En måde lejeafgift",
      total: "Total",
      firstMonthTotal: "Den første måned i alt",
      firstWeekTotal: "Første uge i alt",
      depositPayable: "Depositum (betales på tidspunktet for indsamlingen",
      deposit: "Depositum",
      insuranceCaps: "FORSIKRING",
      customAddon: "Brugerdefineret addon",
      chooseAPolicy: "Vælg en politik",
      rate: "Sats",
      typeOfValet: "Type betjent",
      nonNegotiable: "Ikke til forhandling",
      selectValet: "Vælg Valet",
      collectionAddress: "Indsamlingsadresse",
      remove: "Fjerne",
      deliveryAddress: "Leveringsadresse",
      additionalInformation: "Yderligere oplysninger",
      confirmBooking: "Bekræft reservation",
      proceed: "Fortsætte",
      getQuote: "Få tilbud",
      for: "for",
      agreeWithTermsAndConditions: "Jeg er enig i vilkårene og betingelserne",
      selectCostCenter: "Vælg omkostningscenter til booking",
      action: "Handling",
      name: "Navn",
      enterDrivingLicenceNumber: "Indtast kørekortnummer",
      enterLastName: "Indtast efternavn",
      enterFirstName: "Indtast fornavn",
      enterYourMail: "Indtast din e -mail",
      emailAsterisk: "E -mail*",
      quoteGeneratedCaps: "Citat genereret",
      updated: "Opdateret",
      rentalCharges: "Lejeafgifter",
      totalPayableAmount: "Samlet betaleligt beløb",
      payMinimumAmount:
        "!!!>>> Unexpected token '<', \"<html lang\"... is not valid JSON <<<!!!",
      dueAmountPaidWhilePickup:
        "På grund af beløb, der skal betales på tidspunktet for afhentning",
      payOnCollection: "Betal på indsamling",
      CardAuthorization:
        "Kort vil blive godkendt nu, men beløbet trækkes ud, når",
      starts: "starter",
      confirm: "Bekræfte",
      payAtTimeOfPickup: "Nu og betal på tidspunktet for afhentning",
      payFullAmountNow: "Betal det fulde beløb nu",
      payFullAmountRightAway: "Betal det fulde beløb med det samme",
      FutureChargesRelatedToOngoingBooking:
        "Fremtidige gebyrer relateret til den igangværende reservation vil blive opkrævet denne betalingsmetode",
      saveThisCardForFutureInvoices:
        "Gem dette kort for at foretage betaling for fremtidige fakturaer på dette {{bookingSyntax}}",
      payLater: "Betal senere",
      creditLimitAssigned:
        "Kreditgrænse, der er tildelt til denne virksomhed, vil blive brugt til denne betaling",
      CreditsAgainstBooking: "Kreditter vil blive brugt mod denne reservation",
      useCreditNoteBalance: "Brug kreditnota -saldo",
      telNo: "Tlf. ",
      vatNo: "Moms nr.",
      customer: "Kunde",
      emailAddress: " E -mail -adresse",
      phoneNumber: "Telefonnummer",
      dateCreated: "Dato oprettet",
      poNumber: "PO -nummer",
      dateTime: "Dato og tid",
      dropOffLocation: "Drop-off placering",
      contractHire: "Kontraktudlejning",
      subscription: "Abonnement",
      charges: "Gebyrer",
      enrollmentFees: "Tilmeldingsgebyrer",
      na: "N/a",
      grandTotal: "Grand Total",
      rentalPrice: "Lejepris",
      daysProRated: "dage pro-klassificeret",
      locationSurcharges: "Placering tillæg",
      ofTotalRentalAmount: "af det samlede lejebeløb",
      nextBilling: "Næste fakturering",
      subTotal: "Sub i alt",
      discount: "Rabat",
      discountedPrice: "Rabatteret pris",
      description: "BESKRIVELSE",
      descriptionLabel: "Beskrivelse",
      thisIsA: "Dette er en",
      exemptedBooking: "fritaget reservation",
      thisIstestCourtsey: "Dette er en test/høflighed",
      isCalculatedAgainst: "beregnes imod",
      priceAndSelectedAddons:
        "Pris og nogle udvalgte tilføjelser eksklusive forsikring og indbetaling",
      recurringWeeklyMonthlyInvoice:
        "En tilbagevendende ugentlig/månedlig faktura genereres automatisk til den næste uge/måned.",
      additionalNote: "Yderligere note",
      payableAtVehicleCollection: "Betales på tidspunktet for køretøjssamling",
      purchaseOrderUpdated: "Indkøbsordrenummer opdateret med succes",
      proceedToPay: "Fortsæt med at betale",
      searchResults: "Søgeresultater",
      subscriptions: "Abonnementer",
      contractHireVehicleWeeklyMonthly:
        "Kontraktudlejningskøretøj til ugentligt/månedligt",
      subscribeVehicleWeeklyMonthly:
        "Abonner køretøjet til ugentligt/månedligt",
      contractNow: "Kontrakt nu",
      subscribeNow: "Abonner nu",
      backToBookingCategorySelection:
        "Gå tilbage til valg af booking kategorier.",
      accountVerification: "Kontoverifikation",
      profileNotVerifiedMessage: "Din profil er ikke verificeret. ",
      update: "Opdatering",
      reference: "Reference",
      companyRegistrationNumber: "CO Reg nr",
      availableFrom: "Tilgængelig fra",
      paellaDish: "Paella skål",
      vehicleCatalogues: "Køretøjskataloger",
      vehicleDetails: "Køretøjsdetaljer",
      verification: "Verifikation",
      protectionPlans: "Beskyttelsesplaner",
      authorisedSignatory: "Autoriseret underskriver",
      item: "Punkt",
      price: "Pris",
      unitPrice: "Enhedspris",
      vehicleSpecification: "Køretøjsspecifikation",
      model: "Model",
      color: "Farve",
      bodyType: "Kropstype",
      tankCapacity: "Tankkapacitet",
      interiorColor: "Indvendig farve",
      seats: "Sæder",
      doors: "Døre",
      whatsIncluded: "Hvad er inkluderet",
      timeVehicleSwap: "Tidskøretøjsbytning",
      contractualDetails: "Kontraktlige detaljer",
      longerSubscribeSaveMore:
        "Jo længere du abonnerer på, jo mere kan du gemme",
      tailorSubscriptionToNeeds:
        "Skræddersy dit abonnement på dine specifikke behov",
      easyManagementOnline: "Administrer problemfrit og let online",
      SwapCarAndCancel:
        "Skift din bil, hvis du vil eller annullere til enhver tid",
      customizeYourContract: "Tilpas din kontrakt",
      selectPlan: "Vælg Plan",
      selectTenure: "Vælg ansættelsesperiode",
      tentativeStartDate: "Tentativ startdato",
      selectDate: "Vælg dato",
      selectTime: "Vælg tid",
      contractSummary: "Resumé af din kontrakt",
      subscriptionChargesLabel: "Abonnementsafgifter",
      initialRentalPayment: "Indledende lejebetaling",
      continueToPersonalDetails: "Fortsæt til personlige detaljer",
      noAvailableAddonsFound:
        "Ingen tilgængelige tilføjelser fundet at matche dine søgekriterier",
      nationalInsuranceNumber: "Nationalt forsikringsnummer",
      updateQuote: "Opdatering af citat",
      driverNotAvailable:
        "Driveren er ikke tilgængelig, kontakt med lejeroperatøren",
      selectDeliverySlot: "Vælg Leveringslot",
      wantDelivered: "Vil du have, at det skal leveres?",
      verifyYourLicenceCaps: "Bekræft din licens",
      validateAllFieldsForLicenceCheck:
        " Valider eller indtast følgende detaljer for at fortsætte med licenscheck. ",
      postCode: "Postkode",
      thisAgreementAllows: "Denne aftale tillader det",
      leftoverAgreement:
        "Og vores forsikringspartner til at gennemføre kontrol af dit kørekort og videregive de data, du leverer til forsikringsselskaber og andre relaterede tredjepartier (coastr) til administration af dit køretøjsudlejning, forsikringspolice osv. Accepterer du og samtykker til ovenstående?",
      verifyLicence: "Bekræft licens",
      licenceCheckingInProgress: "Licenskontrol i gang",
      checkingInProgress:
        "Det kan tage op til 2 minutter, vent venligst og ikke opdatere eller lukke din browser",
      licenceCheckingFailed: "Licenskontrol mislykkedes",
      checkForCorrectDetails:
        "Kontroller, om du har indtastet de rigtige detaljer.",
      tryAgainLater:
        "Hvis problemet stadig vedvarer, kan du prøve igen senere.",
      licenceCheckedSuccessfully: "Licens kontrolleret med succes",
      licenceSummaryAdded: "Licensoversigt tilføjet til kundepost",
      creditScore: "Kredit score",
      lastChecked: "Sidste kontrolleret",
      recheckCreditScore: "Kontroller kredit score igen",
      checkCreditScore: "Kontroller kredit score",
      proceedToPayment: "Fortsæt til betaling",
      paymentOverview: "Betalingsoversigt",
      schedule: "Skema",
      contractDetails: "Kontraktoplysninger",
      plan: "Plan",
      swaps: "Swaps",
      payableDeposit: "Betales indbetaling",
      customerVerification: "Kundeverifikation",
      provideAdditionalDetails:
        "Angiv følgende yderligere detaljer inden for kontosektionen for at oprette reservation",
      profilePhoto: "Profilfoto",
      submitYourRequest:
        "Når det er gjort, skal du indsende din anmodning om godkendelse ved at klikke på knappen Indsend nedenfor",
      submit: "indsende",
      uploadLicenceImages: "Upload licensbilleder",
      add: "Tilføje",
      uploadFrontBackLicence: " Upload front- og bagbillede af licens. ",
      uploadLicenceImage: "Upload licensbillede",
      authority: "Myndighed",
      drivingLicenceExpiryDate: "Kørelicens udløbsdato",
      licenceNumber: "Licensnummer",
      preview: "Preview",
      addOn: "Tilføjelse",
      contact: "Kontakte",
      selectSlot: "Vælg slot",
      deliveryType: "Leveringstype",
      experience: "Erfaring",
      type: "Type",
      bookATestDrive: "Book et testkørsel",
      selectASlot: "Vælg en slot",
      selectDateTimeSlot: "Vælg dato og tidsslot",
      vehicleNotAvailable: "Køretøj ikke tilgængeligt til den valgte dato",
      selectDifferentDate: "Vælg en anden dato",
      selectCar: "Vælg en bil",
      availableNow: "Tilgængelig nu",
      new: "Ny",
      phone: "Telefon",
      customerDetails: "Kundeoplysninger",
      dealershipAddress: "Forhandleradresse",
      dealership: "Forhandler",
      bookingTime: "Reservationstid",
      bookingType: "Reservationstype",
      details: "Detaljer",
      your: "Dine",
      confirmation: "Bekræftelse",
      selectDealership: "Vælg et forhandlerfirma",
      testDriveRequested: "Testkørsel anmodet om",
      testDrive: "Testkørsel",
      mobileNumber: "Mobilnummer",
      drivingLicenseNumber: "Kørelicensnummer",
      enterLicenseNumber: "Indtast licensnummer",
      requestTestDrive: "Anmod om testkørsel",
      slot: "Slot",
      vehicle: "Køretøj",
      selectSubsctiption: "Vælg abonnement",
      pricesShownOnSelectedDuration:
        "De viste priser er baseret på valgt varighed",
      priceComparison: "Prissammenligning",
      oneTime: "Én gang",
      subscriptionStartsAt: "Abonnement starter kl",
      paymentProcessing: "Betalingsbehandling",
      pleaseWait: "Vent venligst",
      paymentComplete: "Betaling komplet",
      paymentInProgress: "I gang i gang",
      atleastUploadOne: "Upload i det mindste en",
      upload: "Upload",
      uploadServiceNotAvailable: "Uploadtjeneste ikke tilgængelig. Prøv venligst igen.",
      uploading: "Uploader...",
      atDealership: "Hos forhandler ",
      atHome: "Derhjemme",
      enterYourEmailPassword:
        "Indtast din e -mail og adgangskode for at logge ind",
      enterMailHere: "Indtast din e -mail her",
      required: "Krævet",
      password: "Adgangskode",
      reset: "Nulstil",
      otpForPasswordReset:
        "Du modtager en OTP til nulstilling af adgangskode på din e -mail",
      sendOtp: "Send OTP",
      loginInstead: "Login i stedet",
      verifyOtp: "Bekræft OTP",
      otp: "Otp",
      otpSentToEmail: "OTP er sendt til din e -mail",
      enterOtp: "Indtast OTP",
      enterOtpHere: "Indtast OTP her",
      verify: "Verificere",
      setNewPassword: "Indstil ny adgangskode",
      eightCharLong: "Skal være 8 tegn lange",
      reenterPassword: "Indtast adgangskode her",
      signInAs: "Log ind som",
      as: "Som",
      selectAccountToProceed: "Vælg en konto for at fortsætte",
      personalAccount: "Personlig konto",
      asBusinessCustomer: "Som bussiness -kunde",
      asDriver: "Som chauffør",
      enterPassword: "Indtast adgangskode her",
      registerAs: "Tilmeld dig som",
      individual: "Individuel",
      business: "Forretning",
      operatorMandatedCustomerCheck:
        "Operatøren har mandat til en kundecheck, før du kan få en bekræftet reservation. ",
      createAccount: "Opret konto",
      emailedHowToGetStarted:
        "Vi har e -mailet dig om, hvordan du kommer i gang.",
      ifDontSeeEmail:
        "Hvis du ikke ser e -mailen om et par minutter, skal du kontrollere din 'junk mail' eller 'spam -mappe'.",
      previousVehicleDetails: "Tidligere køretøjsdetaljer",
      registration: "Registrering",
      makeModel: "Lav/model",
      vin: "Vin",
      driverAssigned: "Driver tildelt",
      currentVehicleDetails: "Nuværende køretøjsdetaljer",
      priceGroup: "Priskegruppe",
      unlimitedMileage: "Ubegrænset kilometertal",
      paymentStatus: "Betalingsstatus",
      invoiceNumber: "Fakturanummer",
      deliveryDetails: "Leveringsoplysninger",
      collectionDetails: "Indsamlingsdetaljer",
      coiDetails: "COI detaljer",
      policyName: "Politiknavn",
      planName: "Plannavn",
      policyNumber: "Politiknummer",
      provider: "Udbyder",
      vehicleSwapDetails: "Køretøjsbytningsoplysninger",
      swapMyCar: "Byt min bil",
      NoOfSwapsAllowed: "Antal swaps tilladt",
      NoOfSwapsAvailed: "Antal anvendte swaps",
      NoOfSwapsRemaining: "Antal swaps tilbage",
      swapRequestHistory: "Swap Request History",
      requestedOn: "Anmodet om",
      swapDate: "Swap -dato",
      oldVehicle: "Gammelt køretøj",
      newVehicle: "Nyt køretøj",
      addonsDetails: "Tilføjelsesoplysninger",
      paymentDetails: "Betalingsoplysninger",
      billingPeriod: "Faktureringsperiode",
      creationDate: "Oprettelsesdato",
      invoiceType: "Fakturatype",
      regular: "Fast",
      depositDetails: "Depositumsdetaljer",
      amount: "Beløb",
      totalPaidAmount: "Samlet betalt beløb",
      cancellationCharges: "Annulleringsafgifter",
      totalRefundAmount: "Samlet refusionsbeløb",
      anUnpaid: "en ubetalt",
      aPartiallyPaid: "en delvist betalt",
      thisIs: "Dette er",
      pleaseContactUs: "Kontakt os for yderligere henvendelser",
      reasonToCancelTheBooking: "Vælg en grund til at annullere reservationen",
      enterTheReason: "Indtast årsagen",
      dismiss: "Afskedige",
      selectVehicle: "Vælg køretøj",
      bookingConfirmationInProgress: "Booking bekræftelse i gang",
      pleaseProvideTheReason: "Angiv grunden",
      quote: "Citere",
      management: "Ledelse",
      pickupDateTimePassed: "Enten er afhentningsdato og klokkeslæt gået!  ",
      profileRejectedOrPending:
        "Din profil er enten blevet afvist eller i verserende status",
      testDriveAgreement: "Testkørselaftale",
      rentalAgreement: "Lejeaftale",
      contractHireAgreement: "Kontraktudlejningsaftale",
      subscriptionAgreement: "Abonnementsaftale",
      zeroChargeBooking:
        "Booking af nulopladning kan kun bekræftes af lejeoperatøren",
      pickupDateTimeInPast: "Afhentningsdato og tid er i fortiden",
      creditNoteSummary: "Resume af kreditnotat",
      customerName: "Kundnavn",
      customerEmail: "Kunde -e -mail",
      creditNoteRef: "Kreditnotat ref",
      invoiceRef: "Faktura ref",
      totalAmount: "Samlet beløb",
      amountAdjustedRefunded: "Beløb justeret/refunderet",
      amountAvailable: "Tilgængelig beløb",
      adjustments: "Justeringer",
      particulars: "Oplysninger",
      adjustedToInvoice: "Justeret til faktura",
      adjustedAt: "Justeret til",
      creditNotes: "Kreditnoter",
      availableBalance: "Tilgængelig balance",
      searchCreditNoteId: "Søg kreditnota -id",
      active: "Aktiv",
      exhausted: "Udmattet",
      creditNoteId: "Kreditnotat -id",
      dateGenerated: "Genereret dato",
      amountRefunded: "Beløb tilbagebetalt",
      amountRemaining: "Resterende beløb",
      dashboard: "Dashboard",
      activeVehiclesCount: "Aktive køretøjer tæller",
      totalActiveBookings: "Samlede aktive bookinger",
      totalVehicles: "Samlede køretøjer",
      vehicleChecks: "Køretøjstjek",
      inProgressBookings: "Igangværende bookinger",
      vehicleChecksCompleted: "Køretøjstjek fuldført",
      vehicleChecksPending: "Køretøjstjek afventer",
      dailyBalance: "Daglig balance",
      totalOutstanding: "Samlet udestående",
      UnpaidInvoices: "Antal ubetalte fakturaer",
      regularInvoices: "Regelmæssige fakturaer",
      sundryInvoices: "Diverse fakturaer",
      addNewDriver: "Tilføj ny driver",
      phoneNo: "Telefonnr.",
      drivingLicenceImage: "Kørelicensbillede",
      licenceIssuedBy: "Licens udstedt af",
      licenceExpiryDate: "Licensudløbsdato",
      drivingLicenceIssueDate: "Udstedelsesdato for kørekort",
      pcoIssueDate: "Udstedelsesdato for førerens PCO-licens",
      dateOfBirth: "Fødselsdato",
      taskDetailsNotFound: "Opgaveoplysninger ikke fundet.",
      bookingRef: "Booking Ref",
      rateYourExperience: "Bedøm din oplevelse",
      driverInformation: "Driverinformation",
      saveDrivers: "Gem drivere",
      expiry: "Udløb",
      areYouSureDriver: "Er du sikker på, at du vil fjerne denne driver fra",
      drivers: "Chauffører",
      noDriverFound: "Beklager, ingen chauffører fundet!",
      invoices: "Fakturaer",
      searchInvoiceId: "Søgfaktura -id",
      unpaid: "Ubetalt",
      paid: "Betalt",
      void: "Ugyldig",
      invoiceId: "Faktura -id",
      invoiceDate: "Fakturadato",
      balanceDue: "Forfaldne balance",
      dueDate: "Forfaldsdato",
      invoiceSummary: "Fakturaoversigt",
      invoice: "Faktura",
      sundry: "Diverse",
      addPayment: "Tilføj betaling",
      customerPhoneNumber: "Kundetelefonnummer",
      invoiceReference: "Fakturahenvisning",
      period: "Periode",
      invoiceVoidedBy: "Faktura annulleret af",
      invoicePeriod: "Fakturaperiode",
      invoiceStatus: "Fakturastatus",
      invoiceAmount: "Fakturabeløb",
      amountDue: "Skyld",
      generatedAt: "Genereret kl",
      vehicleRentalCharges: "Gebyrer af køretøjer",
      refundable: "Refunderes",
      date: "Dato",
      thisIsTestCourtsey: "Dette er en test/høflighed",
      invoicesConsolidated: "Fakturaer konsolideret",
      payments: "Betalinger",
      exempted: "fritaget",
      pleaseLoginFirst: "Log ind først",
      account: "Konto",
      tracking: "Sporing",
      uploadImages: "Upload billeder",
      updateVehicleState: "Opdater køretøjstilstand",
      vehicleImage: "Køretøjsbillede",
      fuelStatus: "Brændstofstatus",
      batteryStatus: "Batteristatus",
      odometerReading: "Kilometertællerlæsning",
      nextServiceDetails: "Næste serviceoplysninger",
      serviceType: "Servicetype",
      serviceStatus: "Servicestatus",
      appointmentDate: "Aftaledato",
      estdCompletionDate: "Estd. ",
      serviceProviderName: "Tjenesteudbydernavn",
      serviceProviderAddress: "Tjenesteudbyder -adresse",
      notesForDriver: "Bemærkninger til driver",
      exteriorDamages: "Udvendige skader",
      interiorDamages: "Indvendige skader",
      generalChecks: "Generelle kontroller",
      accessoriesChecks: "Tilbehørskontrol",
      chooseFuelLevel: "Vælg brændstofniveau",
      lastReported: "Sidst rapporteret",
      circumstance: "Omstændighed",
      title: "Titel",
      damageKind: "Skader slags",
      damageArea: "Skadeområde",
      referenceNumber: "Referencenummer",
      damageDetail: "Skaderdetaljer",
      addImage: "Tilføj billede",
      addImages: "Tilføj billeder",
      done: "Færdig",
      searchExistingDriver: "Søg efter eksisterende driver",
      success: "Succes",
      assignDriver: "Tildel driver",
      plate: "Plade",
      unassigned: "Ikke tildelt",
      assigned: "Tildelt",
      make: "Lave",
      vehicleAppearOnceAssigned:
        "Køretøjer vises, når de først er tildelt dig!",
      searchVehicle: "Søgningskøretøj",
      trackingHistoryHrs: "Sporingshistorik (timer)",
      telemetryDevice: "Telemetry -enhed",
      lastLocation: "Sidste placering",
      latitude: "Breddegrad",
      longitude: "Længde",
      forSelectedPeriod: "For valgt periode -",
      milesDriven: "Miles drevet",
      engineHours: "Motorimer",
      fuelUsageLitres: "Brændstofforbrug (liter)",
      stoppagehours: "Stop timer",
      chargeStatus: "Anklagestatus",
      fuelUsage: "Brændstofforbrug",
      batteryLevel: "Batteriniveau",
      speedLimit: "Hastighedsgrænse",
      invalidEmailAddress: "Ugyldig e -mail -adresse",
      unableLoadCompanyDetails: "Kan ikke indlæse virksomhedsoplysninger",
      bookingConfirmationProgress: "Booking bekræftelse i gang ...",
      doNotHitBack:
        "Vær venlig ikke at slå tilbage, annullere eller lukke browseren. ",
      summary: "Oversigt",
      addNew: "Tilføj nyt",
      street: "Gade",
      city: "By",
      regionState: "Region/stat",
      country: "Land",
      zipPostalCode: "Zip/postkode",
      cardAuthorizeNowButAmountLater:
        "Kortet vil blive godkendt nu, men beløbet trækkes, når booking starter",
      saveThisCardForFutureInvoicesBooking:
        "Gem dette kort for at foretage betaling for fremtidige fakturaer på denne reservation.",
      confirmBookingPayLater: "Bekræft reservation, betal senere",
      confirmBookingAndPayAtPickup:
        "Bekræft booking nu og betal på tidspunktet for afhentning",
      bookingReferenceNumber: "Booker referencenummer",
      pickupDetails: "Afhentningsoplysninger",
      dropoffDetails: "Dropoff -detaljer",
      to: "Til",
      bookingReference: "Booker reference",
      invoiceStartDate: "Faktura startdato:",
      invoiceEndDate: "Faktura slutdato:",
      availableAtLocations: "Fås på steder",
      benefits: "Fordele",
      passportNumber: "Pasnummer",
      enterPassportNumber: "Indtast dit pasnummer",
      vehicleSwapRequest: "Anmodning om køretøjsbytning",
      checkVehicleAvailability: "Tjek køretøjets tilgængelighed",
      pleaseSelectDateAndSearch:
        "Vælg dato og klik på søgning efter køretøjets tilgængelighed",
      noVehicleFoundForSelectedDate: "Intet køretøj fundet til den valgte dato",
      notes: "Noter",
      writeYourNoteHere: "Skriv din note her",
      updateRequest: "Opdateringsanmodning",
      generateRequest: "Generere anmodning",
      cancelRequest: "Annuller anmodning",
      operator: "Operatør",
      you: "Du",
      maximum: "Maksimum",
      imagesAreAllowed: "Billeder får lov til at uploade.",
      dragAndDropFile: "Træk og slip en fil eller klik",
      areAllowed: "er tilladt",
      cancelBooking: "Annuller booking",
      booked: "Booket",
      organisation: "Organisation",
      vatNumber: "Momsnummer",
      sort: "Sorter",
      DELETE_DRIVER_DESCRIPTION:
        "Er du sikker på, at du vil slette chaufføren?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Er du sikker på, at du vil slette chaufføren?",
        "Delete Driver": "Slet chauffør",
      },
      currentInvoiceStatus: {
        PAID: "BETALT",
        UNPAID: "UBETALT",
        VOID: "ANNULLERET",
        "PARTIALLY PAID": "DELVIST BETALT",
        DRAFT: "KLADDE",
      },
      currentBookingStatus: {
        CANCELLED: "ANNULLERET",
        COMPLETED: "FULDFØRT",
        "CONFIRMATION IN PROCESS": "BEKRÆFTELSE PÅGÅR",
        CONFIRMED: "BEKRÆFTET",
        "IN PROGRESS": "IGANGVÆRENDE",
        QUOTE: "TILBUD",
        DRAFT: "KLADDE",
        "REQUIRES APPROVAL": "KRÆVER GODKENDELSE",
        DECLINED: "AFVIST",
      },
      minBookingDurationMessage:
        "Minimum bookingvarighed er {{hours}} timer. Juster venligst afhentnings- eller afleveringsdato og -tid i overensstemmelse hermed.",
      maxBookingDurationMessage:
        "Den maksimale bookingvarighed er {{days}} dage. Juster venligst afhentnings- eller afleveringsdato og -tid i overensstemmelse hermed.",
      usevaletTypes: {
        Delivery: "Levering",
        Collection: "Afhentning",
        "Delivery and Collection": "Levering og Afhentning",
      },
      selectCollectionSlot: "Vælg afhentningstidspunkt",
      driverUnavailableNote:
        "Bemærk: Chaufføren er ikke tilgængelig, kontakt venligst udlejningsoperatøren.",
      cancellationReasons: {
        "Requirement changed": "Kravet er ændret",
        Price: "Pris",
        Other: "Andet",
      },
      imagePreview: "Billedforhåndsvisning",
      markDamage: "Markér skade",
      vehicleDamageImages: "Billeder af køretøjsskader",
      incidentDate: "Hændelsesdato",
      incidentTime: "Hændelsestidspunkt",
      clear: "Ryd",
      bookingStatus: "Reservationsstatus",
      daysInBooking: "Dage i reservation",
      accumulatedDays: "akkumulerede dage",
      endingThisMonth: "Slutter denne måned",
      creditUtilisation: "Kreditudnyttelse",
      creditLimit: "Kreditgrænse",
      utilized: "Brugt",
      totalDrivers: "Samlede drivere",
      vehiclesAllocated: "Tildelt køretøjer",
      mileageOverview: "Oversigt over kilometertal",
      mileageLimitExited: "Kilometergrænse afsluttet",
      approachingMileageLimits: "Nærmer sig kilometertalgrænser",
      motReminders: "Mot påmindelser",
      totalMotTests: "Samlede MOT -tests",
      healthCheckReminders: "Påmindelser om helbredstjek",
      totalHealthCheckTests: "Samlede sundhedstjek tests",
      failed: "Mislykkedes",
      serviceReminders: "Service påmindelser",
      overdue: "Forsinket",
      totalServiceReminders: "Samlede service påmindelser",
      createNewServiceRequest: "Opret ny serviceanmodning",
      serviceDetails: "Servicedetaljer",
      selectedVehicle: "Valgt køretøj",
      serviceRequestSelectVehicle: "Vælg køretøj",
      loadingVehicles: "Indlæser køretøjer...",
      noActiveVehiclesFound: "Ingen aktive køretøjer fundet",
      addDetails: "Tilføj detaljer",
      addItems: "Tilføj elementer",
      issueType: "Problemtype",
      issueTypePlaceholder: "f.eks. Defekt lås",
      descriptionPlaceholder: "f.eks. Venstre fordørs lås",
      uploaded: "Uploadet",
      additionalComments: "Yderligere kommentarer",
      additionalCommentsPlaceholder: "Tilføj yderligere information...",
      submitting: "Indsender...",
      submitRequest: "Indsend anmodning",
      serviceRequestNote: "Din anmodning vil blive gennemgået af vores serviceteam. Du vil modtage en notifikation, når den er godkendt, eller hvis yderligere information er nødvendig.",
      serviceRequestDetails: "Detaljer om serviceanmodning",
      createdDate: "Oprettet dato",
      estimatedCost: "Anslået omkostning",
      requestProgress: "Anmodningsforløb",
      issuesReported: "Rapporterede problemer",
      issue: "Problem",
      imageAlt: "Billede",
      serviceProvider: "Serviceudbyder",
      appointment: "Aftale",
      at: "kl",
      estimatedCompletion: "Anslået færdiggørelse",
      workToBeDone: "Arbejde der skal udføres",
      cost: "Omkostning",
      totalCost: "Total omkostning",
      requestDeclined: "Anmodning afvist",
      communication: "Kommunikation",
      serviceTeam: "Serviceteam",
      noCommunicationYet: "Ingen kommunikation endnu",
      addMessage: "Tilføj besked",
      askQuestionPlaceholder: "Stil et spørgsmål eller giv yderligere information...",
      sending: "Sender...",
      sendMessage: "Send besked",
      additionalInformationRequested: "Yderligere information anmodet",
      provideFollowingInformation: "Giv venligst følgende information for at hjælpe os med at behandle din anmodning:",
      yourAnswer: "Dit svar:",
      typeAnswerHere: "Skriv dit svar her...",
      submitAnswers: "INDSEND SVAR",
      approved: "Godkendt",
      serviceRequests: "Serviceanmodninger",
      scheduledServicesTitle: "Planlagte services",
      scheduledServicesBellAria: "Vis planlagte køretøjsservices",
      noScheduledServices: "Ingen planlagte services",
      approveScheduledServiceSuccess: "Service godkendt",
      requestChangesSuccess: "Ændringsanmodning sendt til godkendelse",
      requestChanges: "Anmod om ændringer",
      modifyServiceRequest: "Rediger serviceanmodning",
      modifyDetails: "Rediger detaljer",
      vehicleAndCategory: "Køretøj og kategori",
      cannotModify: "Kan ikke redigeres",
      appointmentDetails: "Aftaledetaljer",
      time: "Tid",
      scheduledServiceReviewHint: "Gennemgå venligst den planlagte service. Godkend hvis detaljerne er korrekte, eller anmod om ændringer.",
      approveService: "Godkend service",
      jobSheet: "Jobseddel",
      declined: "Afvist",
      lastUpdated: "Sidst opdateret",
      explainChangesPlaceholder: "Forklar hvorfor du har brug for disse ændringer...",
      submitChanges: "Send ændringer",
      expenses: "Udgifter",
      filters: "Filtre",
      applyFilters: "Anvend Filtre",
      activeFilters: "Aktive Filtre",
      newServiceRequest: "Ny Serviceanmodning",
      rowsPerPage: "Rækker per side:",
      of: "af",
      moreThan: "mere end",
      searchServiceRequestsPlaceholder: "Søg efter referencenummer, køretøj eller status...",
      selectOption: "Vælg en mulighed",
      selectMultiple: "Vælg en eller flere muligheder",
      uploadPhoto: "Upload foto",
      view: "Vis",
      typeYourResponse: "Skriv dit svar",
      pleaseSelectServiceType: "Vælg venligst en servicetype",
      pleaseSelectServiceCategory: "Vælg venligst en servicekategori",
      selectServiceType: "Vælg servicetype",
      serviceCategory: "Servicekategori",
      selectServiceCategory: "Vælg servicekategori",
      unableToDetermineServiceBranch: "Kunne ikke bestemme din servicefilial. Prøv venligst igen senere.",
      accidentDamageInformation: "Ulykke / Skadeinformation",
      documentUploads: "Dokumentupload",
      adHoc: "Ad-Hoc",
      emergency: "Nødsituation",
      serviceQuestionnaire: "Service Spørgeskema",
      serviceQuestionnaireDescription: "Angiv venligst nogle ekstra detaljer, så vores servicehold kan forberede alt på forhånd.",
      selectServiceCategoryPrompt: "Vælg en servicekategori for at se de påkrævede spørgsmål til denne service.",
      noServiceQuestionsForType: "Ingen yderligere spørgsmål for denne servicetype. Du kan fortsætte med anmodningen.",
      fileUploadGuidance: "JPEG/PNG op til 5 MB pr. fil.",
      optionalServiceQuestion: "Valgfrit spørgsmål — besvar det, hvis det hjælper vores team.",
      requestCreated: "Anmodning Oprettet",
      underReview: "Under Gennemgang",
      inProgress: "I Gang",
      photo: "Foto",
      hiThere: "Hej,",
      serviceRequestDeclinedMessage: "Vi har gennemgået din serviceanmodning, men den kunne ikke godkendes lige nu.",
      whatWeNeed: "Hvad vi har brug for:",
      declineReasonGeneric: "Dette kan skyldes manglende detaljer, serviceberettigelse eller andre godkendelsesbetingelser.",
      declineInstruction: "Gennemgå venligst dine oplysninger og indsend en ny anmodning, når disse opdateringer er på plads.",
      answered: "Besvaret",
      pendingAnswer: "Afventer svar",
      requiredField: "Dette svar er påkrævet",
      questionsAnswered: "spørgsmål besvaret",
      readyToSubmitChanges: "Klar til at sende opdateringer",
      questionsUpToDate: "Alle svar er opdateret",
      updateAnyAnswerToResubmit: "Opdater et hvilket som helst svar ovenfor, hvis du skal sende nye oplysninger.",
      answerTypeText: "Tekst",
      answerTypeYesNo: "Ja / Nej",
      answerTypeDropdown: "Rullemenu",
      answerTypeMultiSelect: "Flere valg",
      answerTypeFileUpload: "Foto-upload",
      pendingApproval: "Afventer Godkendelse",
      awaitingMoreInformation: "Afventer Mere Information",
      closed: "Lukket",
      noServiceRequestsFound: "Ingen serviceanmodninger fundet",
      fleetAllocation: "Flåde Tildeling",
      fleetAllocations: "Flåde Tildelinger",
      userAgreement: "Brugeraftale",
      organisationCode: "Organisationskode",
      serviceReference: "Service Reference",
      completionDate: "Færdiggørelsesdato",
      addTask: "Tilføj Opgave",
      noTaskFound: "Ingen opgaver fundet. Du kan tilføje opgaver manuelt.",
      taskName: "Opgavenavn",
      features: "Funktioner",
      interiorFeatures: "Indvendige Funktioner",
      exteriorFeatures: "Udvendige Funktioner",
      safetyAndTechnicalFeatures: "Sikkerheds- og Tekniske Funktioner",
      otherFeatures: "Andre Funktioner",
      privateHiresNo: "Privatlejekøretøj nr.",
      pcoPrivateHiresHireDLNo: "PCO/privatlejekørekort nr.",
      gender: "Køn",
      secondaryEmailAddress: "Sekundær e-mailadresse",
      secondaryPhoneNumber: "Sekundært telefonnummer",
      driverAge: "Chaufførens alder",
      licenceDuration: "Licens varighed",
      penaltyPoints: "Strafpoint",
      insuranceClaimsHistory: "Historie om forsikringsskader",
      pcoExpiryDate: "PCO‑udløbsdato",
      state: "Stat",
      selectBookingType: "Vælg bookingtype",
      selectBookingTypeDialog: "Vælg venligst en af nedenstående bookingtyper for at fortsætte med bookingen",
      regularBooking: "Almindelig booking",
      contactlessBooking: "Kontaktløs booking",
      reviewBookingDetails: "Gennemgå bookingoplysninger"
    },

    validation: {
      otpLengthMismatch: "Engangskoden skal være på 6 tegn",
      invalidOtp: "Ugyldig engangskode",
      required: "{{field}} er påkrævet",
      billingEmailInvalid: "Indtast en gyldig fakturerings-e-mail.",
      billingEmailRequired: "Fakturerings-e-mail er påkrævet.",
      phoneNumberRequired: "Telefonnummer er påkrævet.",
      businessNameRequired: "Firmanavn er påkrævet.",
      registeredAddressRequired: "Registreret adresse er påkrævet.",
      registeredAddressCountryRequired: "Land er påkrævet.",
      registeredAddressStateRequired: "Stat er påkrævet.",
      registeredAddressCityRequired: "By er påkrævet.",
      registeredAddressStreetRequired: "Gade er påkrævet.",
      tradingAddressRequired: "Handelsadresse er påkrævet.",
      tradingAddressCountryRequired: "Land er påkrævet.",
      tradingAddressStateRequired: "Stat er påkrævet.",
      tradingAddressCityRequired: "By er påkrævet.",
      tradingAddressStreetRequired: "Gade er påkrævet.",
      contactEmailRequired: "Kontakt-e-mail er påkrævet.",
      firstNameRequired: "Fornavn er påkrævet.",
      middleNameRequired: "Mellemnavn er påkrævet.",
      lastNameRequired: "Efternavn er påkrævet.",
      addressRequired: "Adresse er påkrævet.",
      locationRequired: "Placering er påkrævet.",
      emailIsRequired: "E-mail er påkrævet.",
      termsConditionsAccepted: "Vilkår og betingelser skal accepteres.",
      streetZipcodeRequired: "Gade/postnummer er påkrævet.",
      drivingLicenceNumberRequired: "Kørekortnummer er påkrævet.",
      nationalInsuranceNumberRequired:
        "Nationalt forsikringsnummer er påkrævet.",
      nationalityRequired: "Nationalitet er påkrævet.",
      enterValidPhoneNumber: "Indtast et gyldigt telefonnummer.",
      enterValidEmailAddress: "Indtast en gyldig e-mailadresse.",
      authorityRequired: "Myndighed er påkrævet.",
      licenceNumberRequired: "Kørekortnummer er påkrævet.",
      licenceExpiryDateRequired: "Udløbsdato for kørekort er påkrævet.",
      expiryDateRequired: "Udløbsdato er påkrævet.",
      numberIsRequired: "Nummer er påkrævet.",

      passwordLengthValidaion: "Adgangskode skal være mindst 8 tegn lang.",
      passwordContainUppercase:
        "Adgangskoden skal indeholde mindst ét stort bogstav.",
      passwordContainLowercase:
        "Adgangskoden skal indeholde mindst ét lille bogstav.",
      passwordContainOneNumber: "Adgangskoden skal indeholde mindst ét tal.",
      passwordContainSpecialCharacter:
        "Adgangskoden skal indeholde mindst ét specialtegn.",
      passwordMustMatch: "Adgangskoderne skal stemme overens.",
      atleastOneUppercase: "Mindst ét stort bogstav.",
      atleastOneLowercase: "Mindst ét lille bogstav.",
      atleastOneNumericalChar: "Mindst ét tal.",
      atleastOneSpecialChar: "Mindst ét specialtegn.",
      pleaseEnterAValidEmail: "Indtast en gyldig e-mail.",
      driverNotFound: "Chauffør ikke fundet.",
      batteryStatusNumber: "Batteristatus skal være et tal.",
      batteryStatusCantNegative: "Batteristatus kan ikke være negativ.",
      batteryStatusCantMoreHundred: "Batteristatus kan ikke være over 100 %.",
      batteryStatusRequired: "Batteristatus er påkrævet.",
      odometerReadingMustNumber: "Kilometertælleraflæsning skal være et tal.",
      odometerReadingRequired: "Kilometertælleraflæsning er påkrævet.",
      odometerMustEqualOrHigherLast:
        "Kilometertælleraflæsning skal være lig med eller højere end den senest rapporterede værdi.",
      titleIsRequired: "Titel er påkrævet.",
      damageKindIsRequired: "Skadestype er påkrævet.",
      descriptionIsRequired: "Beskrivelse er påkrævet.",
      damageImageIsRequired: "Billede af skade er påkrævet.",
      registrationNumberRequired: "",
      vatRequired: "",
      accountNumberRequired: "",
      professionIsRequired: "Profession er påkrævet",
      passportNineCharacters: "Pasnummer skal være af 9 tegn",
      passportIsRequired: "Pas er påkrævet",
      organisationCodeRequired: "Organisationskode er påkrævet",
      userNotFound: "Bruger ikke fundet",
      invalidPassword: "Ugyldig adgangskode",
      passwordLengthError: "Adgangskoden skal være mindst 8 tegn lang",
      customerPCONumberRequired: "PCO-/privat udlejningslicensnummer er påkrævet",
      genderRequired: "Køn er påkrævet",
    },
    misc: {
      edit: "Rediger",
      logOut: "Log ud",
      licence: "Kørekort",
      cancel: "Annuller",
      save: "Gem",
      status: {
        PENDING: "Afventer",
        APPROVED: "Godkendt",
        DECLINED: "Afvist",
        IN_REVIEW: "Under gennemgang",
      },
      delete: "Slet",
      create: "Opret",
      signIn: "Log ind",
      select: "Vælg",
      back: "Tilbage",
      error: "Fejl",
      yes: "Ja",
      no: "Nej",
      payConfirm: "Betal og bekræft",
      clickToAdd: "Klik for at tilføje",
      close: "Luk",
      download: "Download",
      selectCaps: "VÆLG",

      forgotPassword: "Glemt adgangskode",
      pleaseNote: "Bemærk venligst",
      front: "Forside",

      columnKey: {
        "#": "#",
        Particulars: "Specifikationer",
        Quantity: "Antal",
        "Unit Price": "Enhedspris",
        Duration: "Varighed",
        "Discounted Price": "Rabatteret pris",
        "VAT/TAX": "MOMS/SKAT",
        Amount: "Beløb",
      },
      columnLabelToKeyMap: {
        ITEM: "VARE",
        DESCRIPTION: "BESKRIVELSE",
        QUANTITY: "ANTAL",
        "UNIT PRICE": "ENHEDSPRIS",
        DURATION: "VARIGHED",
        "DISCOUNTED PRICE": "RABATTERET PRIS",
        "VAT/TAX": "MOMS/SKAT",
        PRICE: "PRIS",
      },
      paymentColumnsKey: {
        Date: "Dato",
        Amount: "Beløb",
        "Mode Of Payments": "Betalingsmetode",
        Status: "Status",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Faktura-referencenummer",
        "Vehicle Registration Numbers": "Køretøjets registreringsnummer(e)"
      },
      buttonKey: {
        Rentals: "Udlejninger",
        Subscriptions: "Abonnementer",
        "Test Drive": "Prøvekørsel",
        "Contract Hire": "Langtidsleje",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Book køretøj pr. time eller dag",
        "Subscribe vehicle for weekly/monthly":
          "Abonner på køretøj ugentligt/månedligt",
        "Test Drive our Premium Vehicles": "Prøvekør vores premiumkøretøjer",
        "Contract Hire vehicle for weekly/monthly":
          "Langtidsleje af køretøj på uge-/månedsbasis",
      },
      buttonTextKey: {
        "Subscribe Now": "Abonner nu",
        "Book Now": "Book nu",
        "Contract Now": "Lej nu",
      },
      featuresKey: {
        "Flexible Leasing Options": "Fleksible leasingmuligheder",
        "Choose the duration of your subscription as you go":
          "Vælg varighed for dit abonnement undervejs",
        "Change car anytime*": "Skift bil når som helst*",
        "Home delivery option": "Mulighed for levering til hjemmet",
        "100% digital": "100% digitalt",
        "MOT and taxes": "Syn og afgifter",
        "Without down payment": "Uden udbetaling",
        "Vehicle Servicing": "Køretøjsservice",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Beløb",
        "Adjusted To Invoice": "Justeret til faktura",
        "Adjusted At": "Justeret den",
      },
      categoriesKey: {
        Knowledge: "Viden",
        Behavior: "Adfærd",
        Punctuality: "Punktlighed",
      },
    },
    snackBar: {
      customerInfoSaved: "Kundeoplysninger gemt",
      documentDeleted: "Dokumentet blev slettet",
      documentDeleteFailed: "Kunne ikke slette dokumentet",
      documentDeleteError: "Fejl ved sletning af dokument",
      documentMarkedForDeletion:
        "Dokument markeret til sletning. Ændringer træder i kraft, når du gemmer.",
      profileImageUploaded: "Profilbillede uploadet",
      uploadImageFormatError: "Upload kun billeder i .jpeg/.jpg/.png-format!",
      selectDocumentType: "Vælg dokumenttype",
      selectExpiryDate: "Vælg dokumentets udløbsdato",
      fileSizeExceeded50mb: "Filstørrelsen overstiger grænsen på 50 MB",
      fileSizeExceeded5mb: "Filstørrelsen overstiger grænsen på 5 MB",
      uploadSuccess: "Dokument uploadet",
      invalidUploadFormat: "Upload kun PDF, PNG, JPG eller JPEG filer",
      selectExpiryDateUpload: "Vælg en udløbsdato før du uploader",
      ImageUploaded: "Billede uploadet",

      invalidFileType: "Ugyldig filtype. Tilladte formater: jpeg eller png",
      costCenterInfoMissing: "Oplysninger om omkostningscenter mangler!",
      selectedDriverAlreadyAdded: "Valgt chauffør er allerede tilføjet.",
      driverSavedSuccessfully: "Chauffør gemt",
      additionalDriverCannotBeMore:
        "Ekstra chauffører må ikke overstige antallet af tilkøb",
      verificationStatusInReview: "Verifikationsstatus er under gennemgang",
      verificationStatusPending: "Verifikationsstatus afventer",
      quoteCreated: "Tilbud oprettet",
      bookingCreated: "Booking oprettet",
      pickUpLocationEmpty: "Afhentningssted mangler",
      slotSelectionRequiredForNonNegotiable: "Tidsvalg er påkrævet.",
      protectionPlanMandatoryForPCOBooking:
        "Beskyttelsesplan er påkrævet for denne booking",
      paymentAlreadyDone: "Betaling er allerede gennemført",
      fileBeingGenerated: "Fil oprettes, prøv venligst igen om lidt",

      provideDeliveryAddress: "Angiv leveringsadresse!",
      noValidCreditReadingFound:
        "Ingen gyldig kreditvurdering fundet for dette firma.",
      noValidCreditScoreFound:
        "Ingen gyldig kreditvurdering fundet. Dette kan skyldes overskredet kreditkontrolgrænse.",

      atleastOneLicenceImage: "Upload mindst ét billede af kørekortet",
      licenceImageUploaded: "Kørekortbillede uploadet",
      maximumTwoImageLicence: "Højst to billeder kan uploades for kørekortet!",
      imageUploadInProgress: "Vent venligst, billede uploades...",

      errorFetchingSignedUrl: "Fejl ved hentning af underskrevet URL",
      paymentFailed: "Betalingen mislykkedes, prøv venligst igen",
      paymentFailedReasonCardDetails:
        "Betalingen mislykkedes! Tjek dine kortoplysninger eller prøv igen senere.",
      maximumTwoImage: "Højst to billeder kan uploades for",

      cancelledSuccessfully: "Annulleret",
      selectReasonForCancel: "Indtast en grund til annulleringen",
      streetZipcodeRequired: "Gade / postnummer er påkrævet",
      feedbackSaved: "Tak! Din feedback er gemt",
      driverAlreadyAdded: "Chaufføren er allerede tilføjet!",
      driverRemoved: "Chauffør fjernet",
      businessCustomerDriverDeleted: "Chauffør for erhvervskunde slettet",
      errorInSavingData: "Fejl ved gemning af data",
      damageInformationSaved: "Skadesoplysninger gemt",
      errorSavingData: "Fejl ved gemning af data",
      problemTelematicsData: "Problemer med at indlæse telematikdata",

      verificationRequestSent: "Verifikationsanmodning sendt",
      vehicleStateUpdated: "Køretøjets tilstand er opdateret",
      driverAdded: "Chauffør tilføjet.",
      businessCustomerCreated: "Erhvervskunde oprettet.",
      uploadOnlyImageFiles: "Upload venligst kun billedfiler (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Billedstørrelsen må ikke overstige 5MB",
      uploadFailed: "Upload mislykkedes",
      imagesUploadedSuccessfully: "billede(r) uploadet med succes!",
      failedToUploadImages: "Upload af billeder mislykkedes. Prøv venligst igen.",
      pleaseSelectVehicle: "Vælg venligst et køretøj",
      pleaseFillInAllIssueDetails: "Udfyld venligst alle problemdetaljer",
      serviceRequestCreatedSuccessfully: "Serviceanmodning oprettet! Reference:",
      errorCreatingServiceRequest: "Fejl ved oprettelse af serviceanmodning",
      pleaseEnterNote: "Indtast venligst en note",
      noteAddedSuccessfully: "Note tilføjet",
      errorAddingNote: "Fejl ved tilføjelse af note",
      pleaseAnswerAllRemainingQuestions: "Besvar venligst alle {{count}} resterende spørgsmål{{plural}}",
      answersSubmittedSuccessfully: "Svar indsendt! Din anmodning er nu under gennemgang.",
      errorSubmittingAnswers: "Fejl ved indsendelse af svar",
      serviceRequestNotFound: "Serviceanmodning ikke fundet",
      errorLoadingServiceRequests: "Fejl ved indlæsning af serviceanmodninger",
      oneVehicleForContactless: "Kun ét køretøj kan vælges til kontaktløs booking",
      oneVehicleForNonContactless: "Kun et kontaktløst eller smartcar-køretøj kan vælges til kontaktløs booking",
      contactlessVehicleCannotBeSelected: "Et kontaktløst køretøj kan ikke vælges til almindelige bookinger",
      bookingDetailsCreated: "Bookingoplysninger oprettet"
    },
  },
};